import PropTypes from 'prop-types';
import { useEffect } from 'react';
// next
import { useRouter } from 'next/router';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_AUTH, PATH_HOME, PATH_DASHBOARD, PATH_OFFER, PATH_INVITATION, PATH_ONBOARD } from '../routes/paths';

// ----------------------------------------------------------------------

RegisterGuard.propTypes = {
  children: PropTypes.node,
};

export default function RegisterGuard({ children }) {
  const { push, pathname, query, asPath } = useRouter();
  const { user, isSessionValid, logout } = useAuth();
  const { oid, from } = query;

  useEffect(() => {
    if (user && !isSessionValid()) {
      logout();
      return;
    }

    if (user && !user.crew) {
      if (dataLayer) {
        dataLayer.push({'user_id': user.id, "event": "setUserId"});
      }
      if (user.is_invited) {
        push(PATH_INVITATION.career);
      } else {
        push({pathname: PATH_HOME.application, query });
      }
    } else if (user && user.crew && user.is_crew) {
      if (dataLayer) {
        dataLayer.push({'user_id': user.id, "event": "setUserId"});
      }
      const { status } = user.crew;
      if (status === 'register') {
        push({pathname: PATH_HOME.application, query });
      } else if (status === 'career-done') {
        if (user.is_invited) {
          push(PATH_INVITATION.onboard);
        } else if (from === 'skill') {
          push(PATH_HOME.career);
        } else {
          push({pathname: PATH_HOME.application, query });
        }
      } else if (status === 'application-done') {
        push(PATH_DASHBOARD.process);
      } else if (status === 'crew-hold' || status === 'crew-pass') {
        push(PATH_DASHBOARD.wait);
      } else if (status === 'meeting-requested') {
        push(PATH_DASHBOARD.wait);
      } else if (status === 'black') {
        push(PATH_DASHBOARD.crew);
      } else if (status === 'consulted') {
        if (oid) {
          push({pathname: PATH_DASHBOARD.suggestion, query: { ...query }});
        } else {
          push(PATH_DASHBOARD.suggestion);
        }
      } else if (status === 'applied' || status === 'approved') {
        if (oid) {
          push({pathname: PATH_DASHBOARD.matchingStart, query: { ...query }});
        } else {
          push(PATH_DASHBOARD.matchingStart);
        }
      } else if (status === 'crew') {
        if (from) {
          push(from);
        } else if (oid) {
          push({
            pathname: PATH_OFFER.root,
            query,
          });
        } else {
          push(PATH_DASHBOARD.crew);
        }
      } else if (status === 'crew-fail') {
        if (!user?.crew?.matching_onboarded_at) {
          push(PATH_ONBOARD.root);
        } else if (from) {
          push(from);
        } else if (oid) {
          push({
            pathname: PATH_OFFER.root,
            query,
          });
        } else {
          push(PATH_DASHBOARD.crew);
        }
      } else {
        push(PATH_DASHBOARD.crew);
      }
    } else if (pathname !== PATH_AUTH.register && pathname !== PATH_AUTH.login) {
      push({
        pathname: PATH_AUTH.login,
        query: { ...query, from: asPath, }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return <>{children}</>;
}
